/**
 * Prefixes a host-router path with the current company slug.
 *
 * useTaskNavigation.buildFinalPath does the same thing, but only for task types
 * listed in SLUG_PREFIXED_MFES. The participant payment entry point has no task
 * type, so it must not be routed through that Set: exporting the Set instead
 * would invite inventing a fake task type just to get a slug.
 */
export const withCompanySlug = (path: string, slug: string | null | undefined): string =>
    slug ? `/${slug}${path}` : path;
